import { useQueryClient } from "react-query";
import { useTranslation } from "react-i18next";
import { RemoteApiError } from "../useRemote/types";
import { useRemoteMutation } from "../useRemote/useRemoteMutation";
import type { BookingFavoriteMutationPayload } from "./booking-favorites.types";
import { bookingFavoritesQueryKeys } from "./booking-favorites.query-keys";

export function useRemoteAddBookingFavorite() {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  return useRemoteMutation<void, RemoteApiError, BookingFavoriteMutationPayload>({
    key: ["booking-favorites", "add"],
    url: "/booking-favorites",
    method: "post",
    snackbarTextFunOnFail: error =>
      (error as RemoteApiError)?.response?.data?.message ?? t("_bookingFavorites_errorGeneric"),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries(bookingFavoritesQueryKeys.all);
      if (variables.floorInventoryId != null) {
        queryClient.invalidateQueries(
          bookingFavoritesQueryKeys.byFloor(variables.floorInventoryId)
        );
      }
    }
  });
}
